import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../../../../../common/AdviserProfiles/AdviserProfilePictures/_AdviserProfilePictures.scss'
import defaultProfileImage from '../../../../../images/default-profile-picture.png'
import defaultCompanyImage from '../../../../../images/default-company-logo.png'
import EditButton from '../../../../../common/forms/EditButton'
import { connect } from 'react-redux'
import { actions } from './adviserProfilePicturesEditorActions'
import { Row, Col, Modal } from 'react-bootstrap'
import ImageEditor from '../../../../../common/ImageEditor'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class AdviserProfilePicturesEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingProfilePicture: PropTypes.bool.isRequired,
    editingCompanyPicture: PropTypes.bool.isRequired,
    profilePicture: PropTypes.string,
    companyLogo: PropTypes.string,
    startEditingProfilePicture: PropTypes.func.isRequired,
    stopEditingProfilePicture: PropTypes.func.isRequired,
    cancelEditingProfilePicture: PropTypes.func.isRequired,
    uploadingProfilePicture: PropTypes.bool.isRequired,
    setProfilePicture: PropTypes.func.isRequired,
    profilePictureIsValid: PropTypes.bool.isRequired,

    startEditingCompanyPicture: PropTypes.func.isRequired,
    stopEditingCompanyPicture: PropTypes.func.isRequired,
    cancelEditingCompanyPicture: PropTypes.func.isRequired,
    uploadingCompanyPicture: PropTypes.bool,
    setCompanyPicture: PropTypes.func.isRequired,
    companyPictureIsValid: PropTypes.bool,
    editingProfile: PropTypes.bool.isRequired
  };

  componentDidMount () {
    this.setState({})
  }

  get defaultAvatarScale () { return 1 }
  constructor (props) {
    super(props)
    this.state = {
      profilePictureEditorRef: null,
      companyLogoEditorref: null,
      avatarScale: this.defaultAvatarScale,
      companyLogoscale: 1.2,
      avatarInputRef: null,
      avatarEditorModalIsOpen: false
    }

    this.renderProfilePicture = this.renderProfilePicture.bind(this)
    this.handleFileChange = this.handleFileChange.bind(this)
    this.stopEditingProfilePicture = this.stopEditingProfilePicture.bind(this)
    this.renderCompanyLogo = this.renderCompanyLogo.bind(this)
    this.stopEditingCompanyPicture = this.stopEditingCompanyPicture.bind(this)
  }

  handleFileChange (dataURI) {
    this.props.setProfilePicture(dataURI)
  }

  stopEditingProfilePicture (imageDataUrl) {
    this.props.setProfilePicture(imageDataUrl)
    this.props.stopEditingProfilePicture()
  }

  stopEditingCompanyPicture (imageDataUrl) {
    this.props.setCompanyPicture(imageDataUrl)
    this.props.stopEditingCompanyPicture()
  }

  renderProfilePicture () {
    const defaultProfilePicture = <img src={defaultProfileImage} />
    const profilePicture = this.props.profilePicture ? <img src={this.props.profilePicture} /> : defaultProfilePicture

    return <Col xs={6} sm={6} md={6} lg={6} className={styles['profile-image']}>
      <div>{ this.props.editingProfile && <EditButton
        submitting={false}
        editing={false}
        startEditing={() => { this.props.startEditingProfilePicture() }} /> }
      </div>
      {profilePicture}
      <Modal show={this.props.editingProfilePicture} 
      //container={this} 
      //aria-labelledby='contained-modal-title'
       >
        { <Modal.Body>
          <ImageEditor
            imageTitle='Profile Image'
            handleFileChange={this.handleFileChange}
            image={this.props.profilePicture || defaultProfileImage}
            isOpen={this.props.editingProfilePicture}
            stopEditing={this.stopEditingProfilePicture}
            cancelEditing={() => {
              this.setState({ avatarScale: this.defaultAvatarScale })
              this.props.cancelEditingProfilePicture()
            }} />
        </Modal.Body> }
      </Modal>
    </Col>
  }

  renderCompanyLogo () {
    const defaultCompanyLogo = <img src={defaultCompanyImage} />
    return <Col xs={6} sm={6} md={6} lg={6} className={styles['company-profile-image']}>
      <div>{ this.props.editingProfile && <EditButton
        submitting={false}
        editing={false}
        startEditing={() => { this.props.startEditingCompanyPicture() }} />}
      </div>
      { this.props.companyLogo
        ? <img src={this.props.companyLogo} />
        : defaultCompanyLogo
      }
      <Modal
        show={this.props.editingCompanyPicture}
       // show={true}
       // container={this}
        //</Col> aria-labelledby='contained-modal-title' 
        >
        <Modal.Body>
          { <ImageEditor
            handleFileChange={(imageDataUrl) => {
              this.props.setCompanyPicture(imageDataUrl)
            }}
            imageTitle='Company Logo'
            image={this.props.companyLogo|| defaultCompanyImage}
            isOpen={this.props.editingCompanyPicture}
            stopEditing={this.stopEditingCompanyPicture}
            cancelEditing={() => {
              this.setState({ avatarScale: this.defaultAvatarScale })
              this.props.cancelEditingCompanyPicture()
            }} /> }

        </Modal.Body>
      </Modal>
    </Col>
  }

  render () {
    return <Row>
      { this.renderProfilePicture() }
      { this.renderCompanyLogo() }
    </Row>
  }
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    editingProfilePicture: adviserProfileApprovalEditorContainer.profilePictures.editingProfilePicture,
    uploadingProfilePicture: adviserProfileApprovalEditorContainer.profilePictures.uploadingProfilePicture,
    profilePictureIsValid: adviserProfileApprovalEditorContainer.profilePictures.profilePictureIsValid,
    editingCompanyPicture: adviserProfileApprovalEditorContainer.profilePictures.editingCompanyLogo,
    uploadingCompanyPicture: adviserProfileApprovalEditorContainer.profilePictures.uploadingCompanyPicture,
    submittingCompanyPicture: adviserProfileApprovalEditorContainer.profilePictures.submittingCompanyPicture,
    companyPictureIsValid: adviserProfileApprovalEditorContainer.profilePictures.companyPictureIsValid,
    editingProfile: adviserProfileApprovalEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, set, upload } = actions
  return bindActionCreators({
    startEditingProfilePicture: edit.profilePicture.start,
    stopEditingProfilePicture: edit.profilePicture.stop,
    cancelEditingProfilePicture: edit.profilePicture.cancel,
    setProfilePicture: set.profilePicture,
    indicateProfilePictureUploading: upload.profilePicture,
    startEditingCompanyPicture: edit.companyPicture.start,
    stopEditingCompanyPicture: edit.companyPicture.stop,
    cancelEditingCompanyPicture: edit.companyPicture.cancel,
    setCompanyPicture: set.companyPicture
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfilePicturesEditor))
